<template>
  <v-overlay
    :value="show"
    opacity=".95"
  >
    <div
      class="d-flex flex-inline ma-3 justify-center"
    >
      <v-img
        max-width="40"
        :src="require(`../../assets/dark-${coin.logo}`)"
      />
      <h1
        class="d-flex align-center ma-0"
      >
        {{ qrcode.amount.price }}
      </h1>
    </div>
    <v-card
      color="white"
      class="pa-0 ma-0"
    >
      <v-badge
        color="secondary"
        offset-x="40"
        offset-y="40"
      >
        <template slot="badge">
          <strong>
            {{ qrcode.quote && qrcode.quote.symbol }}
          </strong>
        </template>
        <img
          :src="qrcode.image"
          height="300"
          width="300"
        >
      </v-badge>
      <v-progress-linear
        v-model="countdown"
        height="5"
        class="my-2"
      />
    </v-card>

    <v-card-actions
      class="d-flex flex-column"
    >
      <v-btn
        color="secondary"
        :href="qrcode.alt"
        class="my-2"
      >
        Or open in any crypto wallet
      </v-btn>
      <v-btn
        plain
        color="red"
        @click="$emit('close')"
      >
        <v-icon left>mdi-cancel</v-icon>
        cancel
      </v-btn>
    </v-card-actions>
  </v-overlay>
</template>

<script>
export default {
  props: {
    coin: {
      type: Object,
      default: ()=>{return {}}
    },
    totalAmount: {
      type: Number,
      default: ()=>0
    },
    show: {
      type: Boolean,
    }
  },
  data() {
    return {
      quote: {},
      qrcode: {},
      countdown: 10,
      bufferValue: 20,
      interval: 0,
      busy: false,
    }
  },
  computed: {
    countdownDisplay() {
      return this.countdown.toFixed(2) 
    }
  },
  watch: {
    coin(){
      this.fetch()
    },
    show(opened){
      if (opened) {
        this.startBuffer()
      } else {
        this.countdown = 0
        clearInterval(this.interval)
      }
    },
    async countdown(val) {
      if (val < 100) return
      this.qrcode.image = require("../../assets/qr.gif")
      this.countdown = 0
      this.bufferValue = 10
      await this.fetch()
      this.startBuffer()
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  mounted () {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.busy = true
      this.qrcode = await this.api.get(`/crypto/qrcode/${this.coin.name}/${this.totalAmount}`)
      this.busy = false
    },
    startBuffer () {
      clearInterval(this.interval)
      this.interval = setInterval(() => {
        this.countdown += Math.random() * (15 - 5) + 5
        this.bufferValue += Math.random() * (15 - 5) + 6
      }, 1000)
    },
  },

}
</script>